import React, { useState, useEffect } from 'react';
import { api } from '../api/client';

export default function BatchDatePicker() {
  const [current, setCurrent] = useState(null);
  const [value, setValue] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    api.get('/admin/batch-config').then(data => {
      if (data.batch_start_date) {
        setCurrent(data.batch_start_date);
        // Convert stored ISO string to datetime-local format (YYYY-MM-DDTHH:MM)
        setValue(data.batch_start_date.slice(0, 16));
      }
    }).catch(() => {});
  }, []);

  const save = async () => {
    if (!value) return;
    setSaving(true);
    setMsg(null);
    try {
      await api.put('/admin/batch-config', { batch_start_date: new Date(value).toISOString() });
      setCurrent(new Date(value).toISOString());
      setMsg({ type: 'success', text: 'Batch start date saved.' });
    } catch (err) {
      setMsg({ type: 'error', text: err.message });
    } finally {
      setSaving(false);
    }
  };

  const setToNow = () => {
    const now = new Date();
    const local = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
      .toISOString().slice(0, 16);
    setValue(local);
  };

  return (
    <div className="card" style={{ padding: 16, marginBottom: 20 }}>
      <h4 style={{ margin: '0 0 10px', fontSize: 14 }}>Current Batch Start Date</h4>
      <p style={{ margin: '0 0 10px', fontSize: 12, color: 'var(--text-muted)' }}>
        "Current Batch" in Sales Analytics will show only records from this date onwards.
        {current && (
          <> Currently set to <strong style={{ color: 'var(--text-secondary)' }}>
            {new Date(current).toLocaleString('en-GB')}
          </strong>.</>
        )}
        {!current && <> Not set — Current Batch will show all data.</>}
      </p>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <input
          type="datetime-local"
          value={value}
          onChange={e => setValue(e.target.value)}
          style={{ fontSize: 13 }}
        />
        <button className="btn-secondary btn-small" onClick={setToNow} style={{ fontSize: 12 }}>
          Set to Now
        </button>
        <button className="btn-primary btn-small" onClick={save} disabled={saving || !value} style={{ fontSize: 12 }}>
          {saving ? 'Saving...' : 'Save'}
        </button>
      </div>
      {msg && (
        <div style={{
          marginTop: 8, fontSize: 12, padding: '6px 10px', borderRadius: 'var(--radius-sm)',
          background: msg.type === 'success' ? 'rgba(72,187,120,0.1)' : 'rgba(252,129,129,0.1)',
          color: msg.type === 'success' ? 'var(--success)' : 'var(--danger)',
          border: `1px solid ${msg.type === 'success' ? 'var(--success)' : 'var(--danger)'}`,
        }}>
          {msg.text}
        </div>
      )}
    </div>
  );
}
